import { node } from 'prop-types';
import React, { createContext, PureComponent } from 'react';

import { StorageCookie } from 'reactor/common';

import { C } from 'common';

const Context = createContext();
const { Provider, Consumer: ConsumerEvents } = Context;
const { COOKIE_DOMAIN, MESSAGE: { TYPE }, STORAGE } = C;

class ProviderEvents extends PureComponent {
  static propTypes = {
    children: node,
  };

  static defaultProps = {
    children: undefined,
  };

  state = {
    search: undefined,
    message: undefined,
    title: undefined,
  }

  onSearch = value => this.setState({ search: value.toLowerCase() });

  onError = async ({ code, message: text, title }) => {
    if (code === 401) {
      await StorageCookie.set(STORAGE.AFFILIATE, null, COOKIE_DOMAIN);
      window.location.reload();
    } else {
      this.setState({ message: { text, title, type: TYPE.ERROR } });
    }
  }

  onMessage = (text, title) => this.setState({ message: { text, title, type: TYPE.INFO } });

  render() {
    const {
      onError, onMessage, onSearch,
      props: { children },
      state,
    } = this;

    return (
      <Provider
        value={{
          ...state, onError, onMessage, onSearch,
        }}
      >
        { children }
      </Provider>
    );
  }
}

export { ConsumerEvents, ProviderEvents };
